// Alias
import DefaultHeader from '../../header';
export default DefaultHeader;
//# sourceMappingURL=index.js.map